import { render } from "./Limited.vue?vue&type=template&id=60ea0c68"
import script from "./Limited.vue?vue&type=script&lang=js"
export * from "./Limited.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/PageHeader/Limited.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60ea0c68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60ea0c68', __exports__)) {
    api.reload('60ea0c68', __exports__)
  }
  
  module.hot.accept("./Limited.vue?vue&type=template&id=60ea0c68", () => {
    api.rerender('60ea0c68', render)
  })

}


export default __exports__